import { lazy, Suspense } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import store from './store/store';
import AppThemeProvider from './providers/ThemeProvider';
import HomePage from './pages/HomePage';
import EntityPage from './pages/EntityPage';
import IframePage from './pages/IframePage';
import NotFoundPage from './pages/NotFoundPage';
import ErrorPage from './pages/ErrorPage';

const AllTextsPage = lazy(() => import('./pages/AllTextsPage'));

// Create a client for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <BrowserRouter>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/entity/:insee" element={<EntityPage />} />
              <Route path="/commune/:insee" element={<EntityPage />} />
              <Route path="/iframe" element={<IframePage />} />
              <Route path="/tous-les-textes-indicateurs" element={<AllTextsPage />} />
              <Route path="/tous-les-textes" element={<AllTextsPage />} />
              <Route path="/textes" element={<AllTextsPage />} />
              <Route path="/error" element={<ErrorPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </AppThemeProvider>
    </QueryClientProvider>
  </Provider>
);

export default App;
